import React from 'react';

const sections = [
  {
    title: '1. Aceptación de los Términos',
    content: (
      <p>
        Al contratar, acceder o utilizar los servicios de Ruray Digital ("nosotros", "la
        Plataforma"), usted ("el Cliente") acepta quedar vinculado por estos Términos y
        Condiciones. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar
        nuestros servicios.
      </p>
    ),
  },
  {
    title: '2. Descripción del Servicio',
    content: (
      <p>
        Ruray Digital ofrece una plataforma CRM en la nube para clínicas dentales, que incluye
        bandeja centralizada de WhatsApp para el equipo, agente de inteligencia artificial 24/7,
        agenda y recordatorios automáticos de citas, pipeline de ventas y reportes de métricas en
        tiempo real. El servicio se presta mediante integración con la API de WhatsApp Business de
        Meta Platforms, Inc.
      </p>
    ),
  },
  {
    title: '3. Planes, Precios y Facturación',
    content: (
      <>
        <p>Ofrecemos actualmente dos modalidades de contratación:</p>
        <ul>
          <li>
            <strong>Plan Pro:</strong> facturación mensual recurrente según las tarifas vigentes comunicadas
            al momento de la contratación. La tarifa de instalación puede ofrecerse sin costo durante
            promociones de lanzamiento vigentes.
          </li>
          <li>
            <strong>Plan A Medida:</strong> condiciones, alcance e integraciones acordadas por
            contrato particular entre el Cliente y Ruray Digital.
          </li>
        </ul>
        <p style={{ marginTop: '0.75rem' }}>
          Los precios pueden ajustarse hacia futuros ciclos de facturación con un aviso previo de
          al menos 30 días. El Cliente es responsable de mantener un método de pago válido y
          vigente.
        </p>
      </>
    ),
  },
  {
    title: '4. Proceso de Contratación',
    content: (
      <p>
        La activación del servicio se realiza mediante una demostración y acuerdo comercial directo
        (vía WhatsApp o videollamada agendada), no mediante un flujo de autoservicio o pago
        automatizado en el sitio web. La relación contractual inicia una vez confirmada la
        contratación y realizado el onboarding correspondiente.
      </p>
    ),
  },
  {
    title: '5. Uso Aceptable y Cumplimiento con Meta / WhatsApp',
    content: (
      <>
        <p>
          El Cliente es el único responsable de contar con el consentimiento (opt-in) de sus
          pacientes o contactos antes de comunicarse con ellos a través de la Plataforma, y de
          cumplir en todo momento con la Política de Comercio y los Términos de Servicio de
          WhatsApp Business de Meta.
        </p>
        <ul>
          <li>Queda prohibido el envío de mensajes masivos no solicitados (spam).</li>
          <li>Queda prohibido el uso de la Plataforma para fines fraudulentos, engañosos o ilegales.</li>
          <li>
            Ruray Digital podrá suspender o cancelar el acceso del Cliente si detecta un
            incumplimiento que ponga en riesgo la cuenta de WhatsApp Business, ya sea del Cliente
            o de otros usuarios de la Plataforma.
          </li>
        </ul>
        <p className="disclosure">
          <strong>Nota importante:</strong> Ruray Digital no controla las políticas de suspensión
          de cuentas que Meta aplique directamente sobre el número de WhatsApp Business del
          Cliente, y no garantiza la reversión de dichas suspensiones cuando sean originadas por un
          uso indebido por parte del Cliente.
        </p>
      </>
    ),
  },
  {
    title: '6. Propiedad Intelectual',
    content: (
      <p>
        El software, la marca "Ruray Digital", el diseño de la Plataforma y todo el contenido
        asociado son propiedad exclusiva de Ruray Digital o de sus licenciantes. Esta contratación
        no transfiere ningún derecho de propiedad intelectual al Cliente; únicamente se otorga una
        licencia de uso no exclusiva, intransferible y limitada a la duración de la relación
        contractual.
      </p>
    ),
  },
  {
    title: '7. Cancelación y Reembolsos',
    content: (
      <p>
        El Cliente puede cancelar su suscripción notificando a Ruray Digital con al menos 15 días
        de anticipación al siguiente ciclo de facturación. Los pagos correspondientes a periodos
        ya facturados no son reembolsables, salvo que se acuerde expresamente lo contrario por
        escrito en el contrato particular del Cliente.
      </p>
    ),
  },
  {
    title: '8. Disponibilidad del Servicio y Limitación de Responsabilidad',
    content: (
      <>
        <p>
          Ruray Digital realiza sus mejores esfuerzos para mantener la Plataforma disponible de
          forma continua, sin garantizar un nivel de servicio (SLA) específico en el Plan Pro. Los
          clientes del Plan A Medida podrán contar con un SLA garantizado según lo establecido en
          su contrato particular.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          En la máxima medida permitida por la ley, Ruray Digital no será responsable por
          interrupciones, fallas o cambios de política originados en servicios de terceros
          (incluyendo, sin limitarse a, la API de WhatsApp Business, Meta Platforms, Inc.,
          proveedores de infraestructura en la nube o proveedores de conectividad), ni por daños
          indirectos, incidentales o consecuentes derivados del uso de la Plataforma.
        </p>
      </>
    ),
  },
  {
    title: '9. Protección de Datos',
    content: (
      <p>
        El tratamiento de datos personales de los pacientes y contactos gestionados a través de la
        Plataforma se rige por nuestra{' '}
        <a href="/politica-privacidad" style={{ color: '#00e5d1' }}>
          Política de Privacidad
        </a>
        , la cual forma parte integral de estos Términos y Condiciones.
      </p>
    ),
  },
  {
    title: '10. Modificaciones a estos Términos',
    content: (
      <p>
        Ruray Digital podrá actualizar estos Términos y Condiciones en cualquier momento. Los
        cambios sustanciales serán notificados al Cliente con antelación razonable. El uso
        continuado de la Plataforma tras la publicación de los cambios constituye la aceptación de
        los nuevos términos.
      </p>
    ),
  },
  {
    title: '11. Ley Aplicable y Jurisdicción',
    content: (
      <p>
        Estos Términos y Condiciones se rigen por las leyes de la República del Ecuador. Cualquier
        controversia derivada de su interpretación o cumplimiento se someterá a los jueces y
        tribunales competentes de Ecuador, con renuncia expresa a cualquier otro fuero que pudiera
        corresponder.
      </p>
    ),
  },
  {
    title: '12. Contacto',
    content: (
      <ul>
        <li><strong>Entidad responsable:</strong> Ruray Digital</li>
        <li><strong>País de operación:</strong> Ecuador</li>
        <li>
          <strong>Correo de contacto:</strong>{' '}
          <a href="mailto:support@ruraydigital.com" style={{ color: '#00e5d1' }}>
            support@ruraydigital.com
          </a>
        </li>
      </ul>
    ),
  },
];

const TermsAndConditions: React.FC = () => {
  return (
    <>
      <style>{`
        .tc-root {
          min-height: 100vh;
          background: #000;
          color: #fff;
          font-family: var(--font-body);
          padding: 0;
        }
        .tc-header {
          background: linear-gradient(135deg, rgba(0,229,209,0.08) 0%, rgba(139,92,246,0.08) 100%);
          border-bottom: 1px solid rgba(255,255,255,0.08);
          padding: 3rem 1.5rem 2.5rem;
          text-align: center;
        }
        .tc-logo {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 2rem;
          text-decoration: none;
          color: inherit;
        }
        .tc-logo-dot {
          width: 28px;
          height: 28px;
          border-radius: 8px;
          background: linear-gradient(135deg, #00e5d1, #8b5cf6);
        }
        .tc-logo-text {
          font-family: var(--font-heading);
          font-size: 1.2rem;
          font-weight: 700;
          background: linear-gradient(to right, #00e5d1, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .tc-title {
          font-family: var(--font-heading);
          font-size: clamp(1.8rem, 5vw, 2.8rem);
          font-weight: 800;
          background: linear-gradient(to right, #00e5d1, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.75rem;
        }
        .tc-updated {
          color: #9ca3af;
          font-size: 0.9rem;
        }
        .tc-body {
          max-width: 860px;
          margin: 0 auto;
          padding: 3rem 1.5rem 5rem;
        }
        .tc-intro {
          color: #d1d5db;
          line-height: 1.75;
          margin-bottom: 2.5rem;
          font-size: 1rem;
          padding: 1.5rem;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 12px;
        }
        .tc-section {
          margin-bottom: 2.5rem;
          padding: 1.75rem;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 16px;
          transition: border-color 0.2s;
        }
        .tc-section:hover {
          border-color: rgba(0,229,209,0.2);
        }
        .tc-section h2 {
          font-family: var(--font-heading);
          font-size: 1.15rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .tc-section p {
          color: #d1d5db;
          line-height: 1.75;
          margin-bottom: 0.75rem;
          font-size: 0.95rem;
        }
        .tc-section p:last-child { margin-bottom: 0; }
        .tc-section ul {
          padding-left: 1.5rem;
          margin: 0.75rem 0;
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
        }
        .tc-section li {
          color: #d1d5db;
          line-height: 1.7;
          font-size: 0.95rem;
        }
        .tc-section strong {
          color: #fff;
        }
        .disclosure {
          margin-top: 1rem !important;
          padding: 1rem;
          background: rgba(0,229,209,0.05);
          border: 1px solid rgba(0,229,209,0.15);
          border-radius: 8px;
          color: #e5e7eb !important;
        }
        .tc-footer {
          text-align: center;
          padding: 2rem 1.5rem;
          border-top: 1px solid rgba(255,255,255,0.06);
          color: #6b7280;
          font-size: 0.85rem;
        }
        .tc-footer a {
          color: #00e5d1;
          text-decoration: none;
        }
        .tc-footer a:hover { text-decoration: underline; }
      `}</style>

      <div className="tc-root">
        <header className="tc-header">
          <a href="/" className="tc-logo">
            <div className="tc-logo-dot" />
            <span className="tc-logo-text">Ruray Digital</span>
          </a>
          <h1 className="tc-title">Términos y Condiciones</h1>
          <p className="tc-updated">Última actualización: 13 de agosto de 2026</p>
        </header>

        <main className="tc-body">
          <div className="tc-intro">
            Estos Términos y Condiciones regulan el uso de la plataforma CRM de Ruray Digital,
            orientada a clínicas dentales, incluyendo la bandeja centralizada de WhatsApp, el
            agente de inteligencia artificial, la agenda automática y demás funcionalidades
            asociadas.
            <br /><br />
            Si tiene preguntas adicionales sobre estos Términos, contáctenos en{' '}
            <a href="mailto:support@ruraydigital.com" style={{ color: '#00e5d1' }}>
              support@ruraydigital.com
            </a>.
          </div>

          {sections.map((s) => (
            <section key={s.title} className="tc-section">
              <h2>{s.title}</h2>
              {s.content}
            </section>
          ))}
        </main>

        <footer className="tc-footer">
          <p>© {new Date().getFullYear()} Ruray Digital — Ecuador</p>
          <p style={{ marginTop: '0.5rem' }}>
            <a href="/">← Volver a ruraydigital.com</a>
          </p>
        </footer>
      </div>
    </>
  );
};

export default TermsAndConditions;
